import { getSites, putSite, getWeather } from './_sites';

import { createSlice } from '@reduxjs/toolkit';
import { sites as initialState } from '../initialState';
import { buildAsyncReducers } from '../thunkTemplate';

const { reducer, actions } = createSlice({
  name: 'sites',
  initialState,
  reducers: {
    setSites: (state, { payload }) => ({
      ...state,
      data: payload,
    }),
  },
  extraReducers: (builder) => {
    buildAsyncReducers(builder, [getSites, putSite, getWeather]);
  },
});

const { setSites } = actions;

export { getSites, putSite, setSites, getWeather };
export default reducer;
